module.exports = __webpack_public_path__ + "static/img/d-rulebg.b52fc4e2.webp";